<template>
  <div :class="clase">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 text-center p-0">
          <div v-if="!gala && !miss && !miss_chile && !fiebre_canto && !vecinos" class="tb-banner">
            <img srcset="" :src="urlImg" alt=" " class="d-none d-md-block img-fluid mx-auto" />
             <img srcset="" :src="urlImgMovil" alt=" " class="d-md-none img-fluid mx-auto" />
          </div>
          <div v-else-if="fiebre_canto" class="fiebre-canto-banner">
            <img src="@/assets/fiebre-canto/images/fdc26_logo.png" alt="Fiebre de Canto" class="fiebre-canto-logo">
          </div>
          <div v-else-if="vecinos" class="vecinos-banner">
            <img src="@/assets/vecinos-al-limite/images/val_logo.png" alt="Vecinos al Límite" class="vecinos-logo">
          </div>
          <div v-else-if="gala" class="fes-lc-banner gala-banner">
            <img
                srcset=""
                src="@/assets/gala/images/banner.png"
                alt=" "
                class="img-fluid mx-auto"
            />
            <img src="@/assets/gala/images/logo.png" alt="" class="gala-banner-logo">
          </div>
          <div v-else-if="miss_mundo" class="fes-lc-banner gala-banner">
            <img
                srcset=""
                src="@/assets/miss-mundo/images/logo.png"
                alt=" "
                class="img-fluid mx-auto"
            />
            <img src="@/assets/miss-mundo/images/logo.png" alt="" class="gala-banner-logo">

          </div>
          <div v-else-if="miss_chile" class="fes-lc-banner gala-banner">
            <img
                srcset=""
                src="@/assets/miss-chile/images/logo.png"
                alt=" "
                class="img-fluid mx-auto d-block"
                style="max-width: 220px; margin-top: 40px;"
            />
          </div>
          <div v-else class="fes-lc-banner gala-banner">
            <img src="@/assets/miss/images/logo.png" alt="" class="img-fluid px-5 pt-5">
          </div>
          <div class="p-4">
          <Trivia
              v-if="triviaStatus && !miss"
              :c13="c13"
              :got="got"
              :bunkers="bunkers"
              :mne="mne"
              :clasetext="clasetext"
              :festivallascondes="festivallascondes"
              :gala="gala"
              :miss="miss"
              :miss_mundo="miss_mundo"
              :miss_chile="miss_chile"
              :coliseo="coliseo"
              :festival="festival"
              :mundos="mundos"
              :finde="finde"
              :chv_festivales="chv_festivales"
              :fiebre="fiebre"
              :fiebre_canto="fiebre_canto"
              :vecinos="vecinos"
              :desestrece="desestrece"
              @changeValue="updateParentValue"
          />
          <Mensaje v-if="modal" :clasetext="clasetext" @changeValue="updateParentValue"/>
            <div v-else-if="!modal && !triviaStatus">
              <h1 :class="{ 'py-5': true, [clasetextGracias]: true }">¡Gracias!</h1>
              <h2 :class="clasetextGracias">Participación realizada exitosamente, acabas de sumar {{ (opciones ? opciones : 'más') }} opciones de ganar.</h2>
              <h2 :class="clasetextGracias" style=" font-size: 18px">Pago procesado con {{ status }} para {{ opccion }} con nc {{ nc }}.</h2>
            </div>
          </div>
          <div v-if="miss">
              <h1 :class="{ 'py-5': true, [clasetextGracias]: true }">¡Gracias!</h1>
              <h2 :class="clasetextGracias">Participación realizada exitosamente, acabas de sumar {{ (opciones ? opciones : 'más') }} opciones de ganar.</h2>
              <br>
              <h6 :class="clasetextGracias">Serás redireccionada en 5 segundos</h6>
            </div>
          </div>
        </div>
      </div>
      <div v-if="miss" class="bg-arco">
        <img src="@/assets/miss/images/cierre_web.png" class="img-fluid w-100">
      </div>
      <footer>
    <div class="bg-black text-white fixed-bottom">
      <div class="col text-center"><span>Desarrollado por </span><a href="https://www.celcomlatam.com/"><img srcset="" :src="require('@/assets/galeria/logo_celcom_blanco.svg')" alt="Logo Celcomlatam blanco" class="logo-celcom img-fluid"/></a></div>
    </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Trivia from "@/components/Trivia.vue";
import Mensaje from "@/components/Mensaje.vue";

export default {
  name: 'HomeView',
  components: {
    Trivia,
    Mensaje,
  },
  data() {
    return {
      clase: null,
      clasetext: null,
      clasetextGracias: null,
      urlImg: null,
      urlImgMovil: null,
      c13: false,
      got: false,
      bunkers: false,
      festivallascondes: false,
      mne: false,
      triviaStatus: false,
      status: null,
      opccion: null,
      nc: null,
      gala: null,
      miss: false,
      modal: false,
      opciones: null,
      festival: false,
      mundos: false,
      miss_mundo: false,
      miss_chile: false,
      finde: false,
      coliseo: false,
      chv_festivales: false,
      fiebre: false,
      fiebre_canto: false,
      vecinos: false,
      desestrece: false
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    updateParentValue(data) {
      this.triviaStatus = data.triviaStatus;
      this.modal = data.modal;
      if (this.modal) {
        this.time();
      }
    },
    time() {
      setTimeout(() => {
        // Cambiar el valor de la variable después de 3 segundos (3000 ms)
        this.modal = false;
        this.triviaStatus = true;
      }, 3000); // Cambiar el tiempo (en milisegundos) según tus necesidades
    },
    setLandingPageData(opccion) {
      // Configura valores dinámicos según `opccion`
      switch (opccion) {
        case 'finde':
          this.clase = 'lp-c13-generico vh-100';
          this.clasetext = 'text-black-50 text-uppercase h5';
          this.clasetextGracias = 'text-black-50';
          this.c13 = true;
          this.urlImg = require('@/assets/galeria/banner_c13_desktop.png');
          this.urlImgMovil = require('@/assets/galeria/banner_c13_mobile.png');
          break;
        case 'concurso 13':
        this.clase = 'lp-c13-generico vh-100';
        this.clasetext = 'text-black-50 text-uppercase h5';
        this.clasetextGracias = 'text-black-50';
        this.finde = true;
        this.urlImg = require('@/assets/galeria/finde.png');
        this.urlImgMovil = require('@/assets/galeria/finde_movil.png');
        break;
        case 'c13':
          this.clase = 'lp-c13-generico vh-100';
          this.clasetext = 'text-black-50 text-uppercase h5';
          this.clasetextGracias = 'text-black-50';
          this.c13 = true;
          this.urlImg = require('@/assets/galeria/padre.jpeg');
          this.urlImgMovil = require('@/assets/galeria/padre.jpeg');
          break;
        // case 'desestrece':
        //   this.clase = 'lp-c13-generico vh-100';
        //   this.clasetext = 'text-black-50 text-uppercase h5';
        //   this.clasetextGracias = 'text-black-50';
        //   this.desestrece = true;
        //   this.urlImg = require('@/assets/galeria/c13.png');
        //   this.urlImgMovil = require('@/assets/galeria/c13.png');
        //   break;
        case 'got':
          this.clase = 'bg-dark got-landing bg-gradiente-azul-oscuro-a';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.got = true;
          this.urlImg = require('@/assets/galeria/lnd_got_header_hq.png');
          this.urlImgMovil = require('@/assets/galeria/lnd_got_header_hq.png');
          break;
        case 'bunkers':
          this.clase = 'bg-dark got-landing bg-gradiente-azul-oscuro-a';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.bunkers = true;
          this.urlImg = require('@/assets/galeria/BANNER.png');
          this.urlImgMovil = require('@/assets/galeria/BANNER_mobile.png');
          break;
        case 'chv-festivales':
        this.clase = 'bg-dark got-landing bg-gradiente-azul-oscuro-a';
        this.clasetext = 'text-white text-uppercase h5';
        this.clasetextGracias = 'text-white';
        this.chv_festivales = true;
        this.urlImg = require('@/assets/galeria/chv.png');
        this.urlImgMovil = require('@/assets/galeria/chv.png');
        break;
        case 'mne':
          this.clase = 'bg-dark got-landing bg-gradiente-azul-oscuro-a';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.mne = true;
          this.urlImg = require('@/assets/galeria/LOGO_FONDO_LUCES.jpg');
          this.urlImgMovil = require('@/assets/galeria/LOGO_FONDO_LUCES.jpg');
          break;
        case 'festivallascondes':
          this.clase = 'fes-lc-landing bg-gradiente-azul-oscuro-a';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.festivallascondes = true;
          this.urlImg = require('@/assets/galeria/banner_festival_lc_2.jpg');
          this.urlImgMovil = require('@/assets/galeria/banner_festival_lc_2.jpg');
          break;
        case 'gala':
          this.clase = 'gala vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.gala = true;
          this.urlImg = require('@/assets/gala/images/banner.png');
          this.urlImgMovil = require('@/assets/gala/images/banner.png');
        break;
        case 'miss':
          this.clase = 'gala vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.miss = true;
          this.urlImg = require('@/assets/miss/images/banner.jpg');
          this.urlImgMovil = require('@/assets/miss/images/banner.jpg');
        break;
        case 'missmundo':
          this.clase = 'gala vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.miss_mundo = true;
          this.urlImg = require('@/assets/miss-mundo/images/logo.png');
          this.urlImgMovil = require('@/assets/miss-mundo/images/logo.png');
        break;
        case 'misschile':
          this.clase = 'gala vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.miss_chile = true;
          this.urlImg = require('@/assets/miss-chile/images/logo.png');
          this.urlImgMovil = require('@/assets/miss-chile/images/logo.png');
        break;
        case 'fiebrebaile':
          this.clase = 'gala vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.fiebre = true;
          this.urlImg = require('@/assets/fiebre/images/fdb26_logo.png');
          this.urlImgMovil = require('@/assets/fiebre/images/fdb26_logo.png');
        break;
        // 'fiebre' es el kw de Fiebre de Canto; 'fiebrecanto' se mantiene como alias.
        case 'fiebre':
        case 'fiebrecanto':
          this.clase = 'fiebre-canto vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.fiebre_canto = true;
          this.urlImg = require('@/assets/fiebre-canto/images/fdc26_logo.png');
          this.urlImgMovil = require('@/assets/fiebre-canto/images/fdc26_logo.png');
        break;
        // MercadoPago retorna opccion=MIss con nc=5556; mounted() lo traduce a 'vecinosallimite'.
        case 'vecinosallimite':
          this.clase = 'vecinos vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.vecinos = true;
          this.urlImg = require('@/assets/vecinos-al-limite/images/val_logo.png');
          this.urlImgMovil = require('@/assets/vecinos-al-limite/images/val_logo.png');
        break;
        case 'coliseo':
          this.clase = 'coliseo vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.coliseo = true;
          this.urlImg = require('@/assets/coliseo/logo_coliseo.png');
          this.urlImgMovil = require('@/assets/coliseo/logo_coliseo.png');
        break;
        case 'festival':
          this.clase = 'gala vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.festival = true;
          this.urlImg = require('@/assets/galeria/banner_festival.jpg');
          this.urlImgMovil = require('@/assets/galeria/banner_festival.jpg');
        break;
        case 'mundos':
          this.clase = 'lp-c13-generico vh-100';
          this.clasetext = 'text-black-50 text-uppercase h5';
          this.clasetextGracias = 'text-black-50';
          this.mundos = true;
          this.urlImg = require('@/assets/galeria/banner_c13_desktop.png');
          this.urlImgMovil = require('@/assets/galeria/banner_c13_mobile.png');
          break;
        default:
          this.clase = 'bg-tierra-brava vh-100';
          this.clasetext = 'text-white text-uppercase h5';
          this.clasetextGracias = 'text-white';
          this.urlImg = require('@/assets/galeria/img_tb_main_desktop.jpg');
          this.urlImgMovil = require('@/assets/galeria/img_tb_main.jpg');
          break;
      }
    },
  },
  mounted() {
    // Obtén el valor inicial desde la URL
    this.opciones = this.$route.query.opciones;
    let opccion = this.$route.query.opccion;

    // Cambia el valor de `opccion` si es necesario
    if (opccion === 'coliseo' && this.$route.query.nc === '3338') {
      // MercadoPago de miss-chile retorna opccion=coliseo con nc=3338
      opccion = 'misschile';
      this.opccion = opccion;
    } else if (opccion && opccion.toLowerCase() === 'miss' && this.$route.query.nc === '5556') {
      // MercadoPago de vecinos al límite retorna opccion=MIss con nc=5556
      opccion = 'vecinosallimite';
      this.opccion = opccion;
    } else if (opccion === 'bunkers') {
      opccion = 'festivallascondes';
      this.opccion = opccion;
      // Actualiza la URL
      this.$router.replace({
        query: {
          ...this.$route.query, // Conserva otros parámetros
          opccion, // Cambia `opccion` en la URL
        },
      });
    } else {
      this.opccion = opccion;
    }

    // Si hay éxito y `opccion` está definida
    if (this.$route.query.status === 'success' && this.opccion) {
      this.status = this.$route.query.status;
      this.nc = this.$route.query.nc;
      this.triviaStatus = true;

      // Llama a un método centralizado para manejar las clases y estilos
      this.setLandingPageData(this.opccion.toLowerCase());

      if (this.miss){
        setTimeout(() => {
           this.$router.push('/miss');
        }, 5000); // Cambia el tiempo (en milisegundos) según tus necesidades
      }
    } else {
      // Redirigir a la raíz si no hay parámetros válidos
      if (this.miss){
        setTimeout(() => {
           this.$router.push('/miss');
        }, 5000); // Cambia el tiempo (en milisegundos) según tus necesidades
      }else {
        this.$router.push('/');
      }
    }
  },
}

</script>
<style scoped lang="scss">
@font-face {
  font-family: 'avenir-regular';
  src: url('@/assets/fiebre-canto/fonts/SourceSansPro-Regular.ttf');
}

@font-face {
  font-family: 'avenir-bold';
  src: url('@/assets/fiebre-canto/fonts/SourceSansPro-Black.ttf');
}

.fiebre-canto {
  /* color de respaldo mientras descarga la imagen de fondo */
  background-color: #070b3a;
  background-image: url('@/assets/fiebre-canto/images/fdc26_back.jpg');
  background-position: top center;
  background-size: 100% clamp(340px, 58vw, 470px);
  background-repeat: no-repeat;
  font-family: 'avenir-regular';
  color: #FFF;

  &-banner {
    text-align: center;
    padding: 24px 0 8px;
  }

  &-logo {
    width: 440px;
    max-width: 92%;
  }

  h1, h2, h6 {
    /* negrita real: font-weight sobre avenir-regular solo da negrita sintetica */
    font-family: 'avenir-bold';
  }
}

@media (max-width:768px) {
  .fiebre-canto {
    background-size: 100% 390px;
  }
}

.vecinos {
  /* color de respaldo mientras descarga la imagen de fondo */
  background-color: #0b2a45;
  background-image: url('@/assets/vecinos-al-limite/images/val_back.jpg');
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  font-family: 'avenir-regular';
  color: #FFF;

  &-banner {
    text-align: center;
    padding: 24px 0 8px;
  }

  &-logo {
    width: 440px;
    max-width: 92%;
  }

  h1, h2, h6 {
    /* negrita real: font-weight sobre avenir-regular solo da negrita sintetica */
    font-family: 'avenir-bold';
  }
}

.bg-arco {
    position: absolute;
    bottom: 40px;
    width: 100%;
    overflow: hidden;
}

@media (max-width:768px) {
    .bg-arco {
        height: 150px;
    }
    .gala {
        padding-bottom: 100px;
    }
    .bg-arco img {
        transform: scale(3) translate(0px, 20px);
    }
}
.coliseo {
  /* color de respaldo mientras descarga la imagen de fondo */
  background-color: #372461;
  background-image: url('@/assets/coliseo/bg_coliseo.jpg');
  background-position: center;
  background-size: cover;
}
.gala{
  /* color de respaldo mientras descarga la imagen de fondo */
  background-color: #242549;
  background-image: url('@/assets/gala/images/background.png');
  background-position: center;
  background-size: cover;

  &-banner{
    position: relative;

    &-logo{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 250px;
    }
  }
}
</style>